import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=62373d1e&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62373d1e')) {
      api.createRecord('62373d1e', component.options)
    } else {
      api.reload('62373d1e', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=62373d1e&", function () {
      api.rerender('62373d1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ATzGPgxILAMD/JS/comp/childrenage.vue"
export default component.exports